import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkUpsertMarketingConsentRequest = { info: '_marketingConsent' };
var _bulkUpsertMarketingConsentResponse = {
    results: '_bulkUpsertMarketingConsentResult',
};
var _bulkUpsertMarketingConsentResult = {
    marketingConsent: '_marketingConsent',
};
var _createMarketingConsentByTokenRequest = {};
var _createMarketingConsentByTokenResponse = {
    marketingConsent: '_marketingConsent',
};
var _createMarketingConsentRequest = {
    marketingConsent: '_marketingConsent',
};
var _createMarketingConsentResponse = {
    marketingConsent: '_marketingConsent',
};
var _deleteMarketingConsentRequest = {};
var _deleteMarketingConsentResponse = {};
var _generateLinkRequest = {};
var _generateLinkResponse = {};
var _getConsistentMarketingConsentByIdentifierRequest = {};
var _getConsistentMarketingConsentByIdentifierResponse = {
    marketingConsent: '_marketingConsent',
};
var _getMarketingConsentByIdentifierRequest = {};
var _getMarketingConsentByIdentifierResponse = {
    marketingConsent: '_marketingConsent',
};
var _getMarketingConsentRequest = {};
var _getMarketingConsentResponse = { marketingConsent: '_marketingConsent' };
var _lastConfirmationActivity = { updatedDate: 'google.protobuf.Timestamp' };
var _lastRevokeActivity = { updatedDate: 'google.protobuf.Timestamp' };
var _marketingConsent = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    lastConfirmationActivity: '_lastConfirmationActivity',
    lastRevokeActivity: '_lastRevokeActivity',
};
var _queryMarketingConsentRequest = {};
var _queryMarketingConsentResponse = {
    marketingConsent: '_marketingConsent',
};
var _removeMarketingConsentByTokenRequest = {};
var _removeMarketingConsentByTokenResponse = {
    marketingConsent: '_marketingConsent',
};
var _removeMarketingConsentRequest = {
    lastRevokeActivity: '_lastRevokeActivity',
};
var _removeMarketingConsentResponse = {
    marketingConsent: '_marketingConsent',
};
var _updateMarketingConsentRequest = {
    mask: 'google.protobuf.FieldMask',
    marketingConsent: '_marketingConsent',
};
var _updateMarketingConsentResponse = {
    marketingConsent: '_marketingConsent',
};
var _upsertMarketingConsentRequest = {
    marketingConsent: '_marketingConsent',
};
var _upsertMarketingConsentResponse = {
    marketingConsent: '_marketingConsent',
};
function resolveWixMarketingV1MarketingConsentServiceUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/marketing-consent',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/marketing/v1',
                destPath: '/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a marketing consent. */
export function getMarketingConsent(payload) {
    var _a = serializer(_getMarketingConsentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMarketingConsentResponse, {
        _lastConfirmationActivity: _lastConfirmationActivity,
        _lastRevokeActivity: _lastRevokeActivity,
        _marketingConsent: _marketingConsent,
    }).fromJSON;
    function __getMarketingConsent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'GET',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.GetMarketingConsent',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/marketing-consent/{marketingConsentId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMarketingConsent.fromReq = fromReq;
    __getMarketingConsent.__isAmbassador = true;
    return __getMarketingConsent;
}
/**
 * Retrieves a marketing consent by its details.
 * Required fields:
 * - `details.type`.
 * - `details.email` OR `details.phone`.
 *
 * >**Note:** Due to the ongoing development of our new documentation portal, the query parameter is not displaying as expected. Use the `details` object located in the marketing consent object in the request. You can also see the code example for reference.
 */
export function getMarketingConsentByIdentifier(payload) {
    var _a = serializer(_getMarketingConsentByIdentifierRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMarketingConsentByIdentifierResponse, { _lastConfirmationActivity: _lastConfirmationActivity, _lastRevokeActivity: _lastRevokeActivity, _marketingConsent: _marketingConsent }).fromJSON;
    function __getMarketingConsentByIdentifier(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'GET',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.GetMarketingConsentByIdentifier',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/marketing-consent/get-by',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMarketingConsentByIdentifier.fromReq = fromReq;
    __getMarketingConsentByIdentifier.__isAmbassador = true;
    return __getMarketingConsentByIdentifier;
}
export function getConsistentMarketingConsentByIdentifier(payload) {
    var _a = serializer(_getConsistentMarketingConsentByIdentifierRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getConsistentMarketingConsentByIdentifierResponse, { _lastConfirmationActivity: _lastConfirmationActivity, _lastRevokeActivity: _lastRevokeActivity, _marketingConsent: _marketingConsent }).fromJSON;
    function __getConsistentMarketingConsentByIdentifier(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'GET',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.GetConsistentMarketingConsentByIdentifier',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/marketing-consent/get-by-consistent',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getConsistentMarketingConsentByIdentifier.fromReq = fromReq;
    __getConsistentMarketingConsentByIdentifier.__isAmbassador = true;
    return __getConsistentMarketingConsentByIdentifier;
}
/**
 * Creates a confirmed marketing consent with a `state` of `CONFIRMED`.
 * Required fields:
 * - `details.type`.
 * - `details.email` OR `details.phone`.
 * - `lastConfirmationActivity`.
 *
 * To create a marketing consent with a different state, use Upsert Marketing Consent, or Bulk Upsert Marketing Consent.
 */
export function createMarketingConsent(payload) {
    var _a = serializer(_createMarketingConsentRequest, { _lastConfirmationActivity: _lastConfirmationActivity, _lastRevokeActivity: _lastRevokeActivity, _marketingConsent: _marketingConsent }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMarketingConsentResponse, {
        _lastConfirmationActivity: _lastConfirmationActivity,
        _lastRevokeActivity: _lastRevokeActivity,
        _marketingConsent: _marketingConsent,
    }).fromJSON;
    function __createMarketingConsent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'POST',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.CreateMarketingConsent',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/marketing-consent',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMarketingConsent.fromReq = fromReq;
    __createMarketingConsent.__isAmbassador = true;
    return __createMarketingConsent;
}
/**
 * Update a marketing consent.
 * Required fields:
 * - `details.type`.
 * - `details.email` OR `details.phone`.
 * - `state`.
 *
 * When a marketing consent's `state` is `PENDING` or `CONFIRMED`, the `info.lastConfirmationActivity` field is required.
 * When a marketing consent's `state` is `REVOKED`, the `info.lastRevokeActivity` field is required.
 *
 * >**Note:** For existing marketing consents with `{"type": "EMAIL"}`, you can't update the `state` to `UNKNOWN_STATE`. Trying to do so maintains the current state. However, you can create a new marketing consent and set the `state` to `UNKNOWN_STATE`. Note that you can't create more than a single consent per email or phone number.
 */
export function updateMarketingConsent(payload) {
    var _a = serializer(_updateMarketingConsentRequest, { _lastConfirmationActivity: _lastConfirmationActivity, _lastRevokeActivity: _lastRevokeActivity, _marketingConsent: _marketingConsent }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMarketingConsentResponse, {
        _lastConfirmationActivity: _lastConfirmationActivity,
        _lastRevokeActivity: _lastRevokeActivity,
        _marketingConsent: _marketingConsent,
    }).fromJSON;
    function __updateMarketingConsent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'PATCH',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.UpdateMarketingConsent',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/marketing-consent/{marketingConsent.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMarketingConsent.fromReq = fromReq;
    __updateMarketingConsent.__isAmbassador = true;
    return __updateMarketingConsent;
}
/** Deletes a marketing consent. */
export function deleteMarketingConsent(payload) {
    var _a = serializer(_deleteMarketingConsentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMarketingConsentResponse, {}).fromJSON;
    function __deleteMarketingConsent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'DELETE',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.DeleteMarketingConsent',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/marketing-consent/{marketingConsentId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMarketingConsent.fromReq = fromReq;
    __deleteMarketingConsent.__isAmbassador = true;
    return __deleteMarketingConsent;
}
/**
 * Removes a marketing consent. The consent is cancelled, and the `state` is updated to `REVOKED`.
 * The marketing consent entity still exists, but the recipient is no longer eligible to receive commmunication.
 * To delete a marketing consent entirely, use Delete Marketing Consent.
 *
 * Required fields:
 * - `details.type`.
 * - `details.email` OR `details.phone`.
 * - `info.lastRevokeActivity`.
 */
export function removeMarketingConsent(payload) {
    var _a = serializer(_removeMarketingConsentRequest, { _lastRevokeActivity: _lastRevokeActivity }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeMarketingConsentResponse, {
        _lastConfirmationActivity: _lastConfirmationActivity,
        _lastRevokeActivity: _lastRevokeActivity,
        _marketingConsent: _marketingConsent,
    }).fromJSON;
    function __removeMarketingConsent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'POST',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.RemoveMarketingConsent',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/marketing-consent/remove',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeMarketingConsent.fromReq = fromReq;
    __removeMarketingConsent.__isAmbassador = true;
    return __removeMarketingConsent;
}
/** CreateMarketingConsent the specified marketing_consent in the token */
export function createMarketingConsentByToken(payload) {
    var _a = serializer(_createMarketingConsentByTokenRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMarketingConsentByTokenResponse, { _lastConfirmationActivity: _lastConfirmationActivity, _lastRevokeActivity: _lastRevokeActivity, _marketingConsent: _marketingConsent }).fromJSON;
    function __createMarketingConsentByToken(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'POST',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.CreateMarketingConsentByToken',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/marketing-consent/createMarketingConsentByToken',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMarketingConsentByToken.fromReq = fromReq;
    __createMarketingConsentByToken.__isAmbassador = true;
    return __createMarketingConsentByToken;
}
/** RemoveMarketingConsent the specified marketing_consent in the token */
export function removeMarketingConsentByToken(payload) {
    var _a = serializer(_removeMarketingConsentByTokenRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeMarketingConsentByTokenResponse, { _lastConfirmationActivity: _lastConfirmationActivity, _lastRevokeActivity: _lastRevokeActivity, _marketingConsent: _marketingConsent }).fromJSON;
    function __removeMarketingConsentByToken(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'POST',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.RemoveMarketingConsentByToken',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/marketing-consent/removeMarketingConsentByToken',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeMarketingConsentByToken.fromReq = fromReq;
    __removeMarketingConsentByToken.__isAmbassador = true;
    return __removeMarketingConsentByToken;
}
/**
 * Retrieves a list of marketing consents, given the provided paging, filtering, and sorting. Up to 100 marketing consents can be returned per request.
 *
 * The default `sort` is `id` in `ASC` order. For a detailed list of supported operations, see filtering and sorting for marketing consent properties. To learn how to query marketing consents, see API Query Language.
 */
export function queryMarketingConsent(payload) {
    var _a = serializer(_queryMarketingConsentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMarketingConsentResponse, {
        _lastConfirmationActivity: _lastConfirmationActivity,
        _lastRevokeActivity: _lastRevokeActivity,
        _marketingConsent: _marketingConsent,
    }).fromJSON;
    function __queryMarketingConsent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'POST',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.QueryMarketingConsent',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/marketing-consent/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMarketingConsent.fromReq = fromReq;
    __queryMarketingConsent.__isAmbassador = true;
    return __queryMarketingConsent;
}
/**
 * Creates or updates a marketing consent.
 * Required fields:
 * - `details.type`.
 * - `details.email` OR `details.phone`.
 * - `state`.
 *
 * When a marketing consent's `state` is `PENDING` or `CONFIRMED`, the `info.lastConfirmationActivity` field is required.
 * When a marketing consent's `state` is `REVOKED`, the `info.lastRevokeActivity` field is required.
 *
 * >**Note:** For existing marketing consents with `{"type": "EMAIL"}`, you can't update the `state` to `UNKNOWN_STATE`. Trying to do so maintains the current state. However, you can create a new marketing consent and set the `state` to `UNKNOWN_STATE`. Note that you can't create more than a single consent per email or phone number.
 */
export function upsertMarketingConsent(payload) {
    var _a = serializer(_upsertMarketingConsentRequest, { _lastConfirmationActivity: _lastConfirmationActivity, _lastRevokeActivity: _lastRevokeActivity, _marketingConsent: _marketingConsent }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_upsertMarketingConsentResponse, {
        _lastConfirmationActivity: _lastConfirmationActivity,
        _lastRevokeActivity: _lastRevokeActivity,
        _marketingConsent: _marketingConsent,
    }).fromJSON;
    function __upsertMarketingConsent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'POST',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.UpsertMarketingConsent',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/marketing-consent/upsert',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __upsertMarketingConsent.fromReq = fromReq;
    __upsertMarketingConsent.__isAmbassador = true;
    return __upsertMarketingConsent;
}
/**
 * Creates or updates multiple marketing consents.
 * Required fields:
 * - `details.type`.
 * - `details.email` OR `details.phone`.
 * - `state`.
 *
 * When a marketing consent's `state` is `PENDING` or `CONFIRMED`, the `info.lastConfirmationActivity` field is required.
 * When a marketing consent's `state` is `REVOKED`, the `info.lastRevokeActivity` field is required.
 *
 * >**Note:** For existing marketing consents with `{"type": "EMAIL"}`, you can't update the `state` to `UNKNOWN_STATE`. Trying to do so maintains the current state. However, you can create a new marketing consent and set the `state` to `UNKNOWN_STATE`. Note that you can't create more than a single consent per email or phone number.
 */
export function bulkUpsertMarketingConsent(payload) {
    var _a = serializer(_bulkUpsertMarketingConsentRequest, { _lastConfirmationActivity: _lastConfirmationActivity, _lastRevokeActivity: _lastRevokeActivity, _marketingConsent: _marketingConsent }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpsertMarketingConsentResponse, {
        _bulkUpsertMarketingConsentResult: _bulkUpsertMarketingConsentResult,
        _lastConfirmationActivity: _lastConfirmationActivity,
        _lastRevokeActivity: _lastRevokeActivity,
        _marketingConsent: _marketingConsent,
    }).fromJSON;
    function __bulkUpsertMarketingConsent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'POST',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.BulkUpsertMarketingConsent',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/bulk/marketing-consent/upsert',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpsertMarketingConsent.fromReq = fromReq;
    __bulkUpsertMarketingConsent.__isAmbassador = true;
    return __bulkUpsertMarketingConsent;
}
/**
 * Creates an unsubscribe link to be shared with the relevant recipient.
 *
 * If someone clicks the **Unsubscribe** button on the confirmation page,
 * the recipient's `subscriptionStatus` is changed to `UNSUBSCRIBED`.
 */
export function generateLink(payload) {
    var _a = serializer(_generateLinkRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateLinkResponse, {}).fromJSON;
    function __generateLink(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.marketing.marketing_consent.v1.marketing_consent',
            method: 'POST',
            methodFqn: 'wix.marketing.v1.MarketingConsentService.GenerateLink',
            url: resolveWixMarketingV1MarketingConsentServiceUrl({
                protoPath: '/v1/marketing-consent/generate-link',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateLink.fromReq = fromReq;
    __generateLink.__isAmbassador = true;
    return __generateLink;
}
//# sourceMappingURL=http.impl.js.map